import template from './main_page.html'
import './main_page.css'

export default {
  template,
  controller: 'mainPageController as mainPage'
}
